export const data = [
    {
        id: "0",
        question: "Do you need prior experience to join FRC?",
        answer: "No, but it it would be awesome if you were part of FLL or FTC.",
        variants: [`No, FRC is easy-peasy.`, `Yes, you will fall behind otherwise.`, `No, but it it would be awesome if you were part of FLL or FTC.`, `Yes, the foundations must be built with FLL and FTC.`]
    },
    {
        id: "1",
        question: "What are the subcategories of FRC?",
        answer: "Build, Business, Software",
        variants: [`FLL, FTC, FRC`, `Pinky, Blinky, Dinky`, `Design, Drive, Delivery`, `Build, Business, Software`]
    },
    {
        id: "2",
        question: "What is one language that FRC software can be programmed in?",
        answer: "Java",
        variants: [`BASIC`, `Dart`, `Swift`, `Java`]
    },
    {
        id: "3",
        question: "What does FRC business do?",
        answer: "Submitting grants, imagery-related tasks, and managing fundraisers.",
        variants: [`Submitting grants, imagery-related tasks, and managing fundraisers.`, `Code the robot`, `Carry out formal meetings with company executives on a daily basis.`, `Build the robot`]
    },
]

// {
//     id: "3",
//     question: "",
//     answer: "",
//     variants: [``, ``]
// },